module.exports = "/_next/static/images/b1d32368f7c53c105ccff2d3d14d5b7a-holding-device-smile@0.5x.jpg.webp";